import './scss/index.scss';
import ComponentsFactory from 'foundation/components-factory';
import NewsFeedLiveSelector from './js/news-feed-live-selector.component';

ComponentsFactory.getInstance().define('news-feed-live-selector', NewsFeedLiveSelector);
